import { render, staticRenderFns } from "./GxLogin.vue?vue&type=template&id=00a4f445&scoped=true&"
import script from "./GxLogin.vue?vue&type=script&lang=js&"
export * from "./GxLogin.vue?vue&type=script&lang=js&"
import style0 from "./GxLogin.vue?vue&type=style&index=0&id=00a4f445&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4f445",
  null
  
)

export default component.exports